"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indent = void 0;
function indent(depth) {
    const indentation = '  ';
    return indentation.repeat(depth);
}
exports.indent = indent;
//# sourceMappingURL=helpers.js.map